import { styled } from '@mui/material/styles';
import { brandclub_colors } from '@stackline/ui';

export const Page = styled('div')({
  color: '#0E1E3A',
  paddingBottom: 36
});

export const Layout = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr',
  gap: '60px'
});

export const Sidebar = styled('div')({
  background: brandclub_colors.white,
  border: '1px solid #E6ECF2',
  borderRadius: 8,
  padding: 12,
  height: 'fit-content',
  display: 'flex',
  flexDirection: 'column'
});

export const SidebarTitle = styled('div')({
  fontWeight: 700,
  fontSize: 20
});

export const SidebarItem = styled('button')<{ active?: boolean }>(({ active }) => ({
  padding: '10px 12px',
  margin: '6px 0',
  borderRadius: 8,
  fontSize: 14,
  fontWeight: 500,
  color: active ? brandclub_colors.darkBlue : '#0E1E3A',
  background: active ? '#ECF2FF' : 'transparent',
  border: active ? '1px solid #D7E3FF' : '1px solid transparent',
  cursor: 'pointer',
  textAlign: 'left',
  display: 'block',
  width: '100%'
}));

export const Header = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: 60
});

export const Title = styled('h1')({
  margin: 0,
  fontSize: 24,
  fontWeight: 600
});

export const InlinePill = styled('div')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 12,
  padding: '10px 12px',
  border: '1px solid #E6ECF2',
  borderRadius: 8,
  background: brandclub_colors.white
});

export const Dropdown = styled('button')({
  border: '1px solid #E6ECF2',
  background: brandclub_colors.white,
  borderRadius: 8,
  padding: '8px 10px',
  fontSize: 14,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8
});

export const DropdownContainer = styled('div')({
  position: 'relative',
  display: 'inline-block'
});

export const Menu = styled('div')({
  position: 'absolute',
  top: '110%',
  right: 0,
  background: brandclub_colors.white,
  border: '1px solid #E6ECF2',
  borderRadius: 8,
  boxShadow: '0 8px 24px rgba(14,30,58,0.12)',
  zIndex: 10,
  minWidth: 140,
  padding: 6
});

export const MenuItem = styled('button')({
  width: '100%',
  textAlign: 'left',
  background: 'transparent',
  border: 'none',
  borderRadius: 6,
  padding: '8px 10px',
  fontSize: 14,
  cursor: 'pointer',
  color: '#0E1E3A'
});

export const KPIGrid = styled('div')({
  display: 'inline-flex',
  gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
  gap: 24,
  width: '100%'
});

export const KPI = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  marginRight: '70px',
  width: '175px',
  paddingRight: '20px',
  paddingLeft: '20px',
  paddingBottom: '28px',
  paddingTop: '28px'
});

export const KpiLabel = styled('div')({
  overflow: 'hidden',
  color: '#242424',
  fontFeatureSettings: "'liga' off, 'clig' off",
  textOverflow: 'ellipsis',
  fontFamily: 'Roboto',
  fontSize: 14,
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '28px',
  letterSpacing: '0.96px',
  textTransform: 'uppercase',
  marginBottom: 12,
  width: '100%'
});

export const KpiValue = styled('div')({
  fontSize: 40,
  fontWeight: 700
});

// Shared form label for configuration sections
export const FormLabel = styled('div')({
  overflow: 'hidden',
  color: 'var(--primary-031425, #031425)',
  fontFeatureSettings: "'liga' off, 'clig' off",
  textOverflow: 'ellipsis',
  fontFamily: 'Roboto',
  fontSize: 14,
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '20px',
  letterSpacing: '0.08px',
  marginBottom: 8
});

export const Table = styled('table')({
  width: '100%',
  borderCollapse: 'separate',
  borderSpacing: 0,
  fontSize: 14
});

export const Th = styled('th')({
  textAlign: 'left',
  color: 'var(--primary-031425, #031425)',
  fontFeatureSettings: "'liga' off, 'clig' off",
  fontFamily: 'Roboto',
  fontSize: 12,
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '20px',
  letterSpacing: '1.2px',
  textTransform: 'uppercase',
  padding: '12px 16px'
});

export const Td = styled('td')({
  padding: '16px',
  verticalAlign: 'middle',
  transition: 'background 0.12s ease-in-out',
  borderTop: '1px solid #E6ECF2'
});

export const Status = styled('span')<{ variant?: 'enabled' | 'disabled' }>(({ variant }) => ({
  padding: '6px 10px',
  borderRadius: 12,
  background: variant === 'disabled' ? '#FFDDDB' : '#E2F6F1',
  fontFeatureSettings: "'liga' off, 'clig' off",
  fontFamily: 'Roboto',
  fontSize: 12,
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '18px',
  letterSpacing: '0.08px'
}));

export const Steps = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  fontSize: 12,
  color: '#031425',
  marginBottom: 12
});

export const Step = styled('button')<{ active?: boolean }>(({ active }) => ({
  fontWeight: active ? 600 : 500,
  color: active ? '#0E1E3A' : '#031425',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer'
}));

export const ClickableRow = styled('tr')({
  cursor: 'pointer',
  '&:hover td': {
    background: '#F7FAFF'
  }
});
